import InputPassword from '../Form/Fields/InputPassword';
import '../Modal/CreateProductModal.scss';

const PasswordSection = () => {
  return (
    <div className="cdm-grid-2">
      <div>
        <label className="cdm-field-label">Nouveau mot de passe</label>
        <InputPassword name="newPassword" placeholder="Nouveau mot de passe" />
      </div>
      <div>
        <label className="cdm-field-label">Confirmer le mot de passe</label>
        <InputPassword name="confirmPassword" placeholder="Confirmer le mot de passe" />
      </div>
    </div>
  );
};

export default PasswordSection;
